import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
import BasicDialog from "../../Components/BasicDialog";
import Progressbar from "../../Components/Progressbar";
/** Components Import */
import Mm10060View from "../../Views/Manufacture/MM10060";
import Mm10061View from "../../Views/Manufacture/MM10061";
import Snackbar from "../../Components/Snackbar";
import { useNavigate } from "react-router-dom";

function MM10060(props) {
  const navigate = useNavigate(); // Route move api
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [dialog, setDialog] = React.useState({
    open: false,
    title: "",
    children: "",
    saveButtonName: "저장",
    onSave: () => {},
  });
  const [progress, setProgressbar] = React.useState(false);
  const [machineData, setMachineData] = React.useState([
    {
      value: "",
      name: "",
    },
  ]);
  const [machineInputs, setMachineInputs] = React.useState({
    machineCd: "",
  });
  const [inputs, setInputs] = React.useState({
    processList: [],
    barcodeValue: "",
    title: "생산실적관리",
    switchValue: false,
    workOrderValue: "",
    currentWorkOrderQty: 0,
    startEnd: "0",
    startEndRadio: [
      {
        value: "0",
        name: "시작",
      },
      {
        value: "1",
        name: "종료",
      },
      {
        value: "3",
        name: "중간출력",
      },
      {
        value: "2",
        name: "최종/출력",
      },
    ],
    woNo: "",
    processNm: "",
    userNm: "",
    itemCd: "",
    itemNm: "",
    itemType: "",
    processCd: "",
    orSeq: "",
    machineCd: "",
    checkProcessCd1: [],
    checkProcessCd2: [],
    checkProcessCd3: [],
    machineList: [],
  });
  const [woNoInputs, setWoNoInputs] = React.useState({
    wkSeq: -1,
    worker: "",
    wkOutSrc: "Y",
    wkType: "Y",
    wkStDt: "",
    wkEdDt: new Date(),
    seqQty: 0,
    seqFailQty: 0,
    radioJumpQty: "10",
    radioJumpQty1: "10",
    remark: "",
    processCd: "",
    woNo: "",
    itemCd: "",
    endProcess: "",
    remark: "",
    cartonQuantity: 0,
  });
  const [startDate, setStartDate] = React.useState(new Date());
  const [lsatProcessList, setLastProcessList] = React.useState({
    createId: "",
    processNm: "",
    seqFailQty: "",
    seqQty: "",
    wkEtDt: new Date(),
    wkOutSrc: "",
    wkStDt: new Date(),
  });
  const [processCdCheck, setProcessCdCheck] = React.useState(false);
  const [bomList, setBomList] = React.useState([]);
  const [checkProcessCd, setCheckProcessCd] = React.useState({});
  const [saveWoNo, setSaveWoNo] = React.useState("");
  // const [saveProcessNm, setSaveProcessNm] = React.useState("");
  let saveProcessNm = "";
  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);
  React.useEffect(() => {}, []);
  const Init = async () => {
    // Dialog.ProgressBar(true);
    setProgressbar(true);

    let userInfo = null;

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });

      // setInputs({
      //   ...inputs,
      //   userNm: userInfo.userNm,
      // });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      // Dialog.ProgressBar(false);
      setProgressbar(false);
    }
  };

  //설비 콤보 데이터
  const GetMachineData = async (processCd) => {
    let getMachineData = [];
    await Commons.Axios(
      "get",
      Global.serverUrls.useUrl + Global.urls.logic.Common.GetMachine,
      {
        processCd: processCd,
        machineCd: "string",
      }
    ).then((result) => {
      let data = result.data;
      getMachineData.push({
        value: "",
        name: "",
      });
      if (data === "데이터가 없습니다.") {
      } else {
        for (let i = 0; i < data.length; i++) {
          getMachineData.push({
            value: data[i].value,
            name: data[i].name,
          });
        }
      }
      setMachineData(getMachineData); //groupCd: "PROCESS_CD"
    });
  };
  //작업지시번호스캔
  const WoNoSearch = async (_woNo) => {
    // Dialog.ProgressBar(true);
    setProgressbar(true);

    let userInfo = null;
    let getLanData = [];
    let getRowData = [];
    let a = [];
    let b = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10060.GetWork,
        {
          woNo: _woNo ? _woNo : inputs.barcodeValue,
        }
      ).then((result) => {
        let data = result.data;
        if (data.length === 0) {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_ CheckWoNo" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setInputs({
            ...inputs,
            barcodeValue: "",
          });
        } else if (data == "생산이 완료된 작업입니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: data,
          });
          setInputs({
            ...inputs,
            barcodeValue: "",
          });
        } else {
          setInputs({
            ...inputs,
            woNo: data[0].woNo,
            itemNm: data[0].ItemNm,
            wkStDt: data[0].wkStDt ? data[0].wkStDt.replace("T", " ") : "",
            wkEdDt: data[0].wkEdDt ? data[0].wkEdDt.replace("T", " ") : "",
            // itemType: data.itemType,
            workOrderValue: saveProcessNm, //공정
            // currentWorkOrderValue: data.length > 1 ? data[1].processNm : "", //최근공정
            currentWorkOrderValue:
              data[0].currentWorkOrderQty == 0 && data[1]
                ? data[1].processNm
                : data[0].processNm,
            currentWorkOrderQty:
              data[0].currentWorkOrderQty == 0 && data[1]
                ? data[1].currentWorkOrderQty
                : data[0].currentWorkOrderQty,
            barcodeValue: "",
            // processCd: data.processCd,
            // orSeq: data.CurrentWorks.OrSeq,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
      setInputs({
        ...inputs,
        barcodeValue: "",
      });
    } finally {
      // Dialog.ProgressBar(false);
      setProgressbar(false);
    }
  };

  //작업자스캔
  const UserSearch = async (_value) => {
    // Dialog.ProgressBar(true);
    setProgressbar(true);

    let userInfo = null;
    let getLanData = [];
    let getRowData = [];

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10060.GetUserInfo,
        {
          userId:
            _value == "" || _value == undefined || _value == null
              ? inputs.barcodeValue
              : _value,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: data,
          });
        } else if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: "데이터가 없습니다.",
          });
        } else {
          setInputs({
            ...inputs,
            userNm: data[0].UserNm,
            userId: data[0].userId,
            barcodeValue: "",
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      // Dialog.ProgressBar(false);
      setProgressbar(false);
    }
  };

  const ProcessNmSearch = async (_value) => {
    await Commons.Axios(
      "get",
      Global.serverUrls.useUrl +
        Global.urls.logic.Manufacture.MM10060.GetProcInfo,
      {
        processCd:
          _value == "" || _value == undefined || _value == null
            ? inputs.barcodeValue
            : _value,
      }
    ).then((result) => {
      let data = result.data;
      saveProcessNm = data[0].ProcessNm;
      setInputs({
        ...inputs,
        barcodeValue: "",
        workOrderValue: data[0].ProcessNm,
      });
    });
    // WoNoSearch(saveWoNo);
  };

  //공정코드스캔
  const ProcessCdSearch = async (_value) => {
    // Dialog.ProgressBar(true);
    setProgressbar(true);

    let userInfo = null;
    let getLanData = [];
    let getRowData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      if (!inputs.woNo || inputs.woNo == "" || inputs.woNo == undefined) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "지시바코드를 먼저 적용해주세요",
        });
        setInputs({
          ...inputs,
          barcodeValue: "",
        });
      } else if (!inputs.userNm) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "작업자를 스캔해주세요",
        });
        setInputs({
          ...inputs,
          barcodeValue: "",
        });
      } else {
        await Commons.Axios(
          "get",
          Global.serverUrls.useUrl +
            Global.urls.logic.Manufacture.MM10060.GetManuWork,
          {
            startEnd: inputs.startEnd,
            noChk: "1",
            woNo: inputs.woNo,
            processCd:
              _value == "" || _value == undefined || _value == null
                ? inputs.barcodeValue
                : _value,
            userInfo: userInfo.userId,
            worker: inputs.userId,
          }
        ).then((result) => {
          let data = result.data;
          switch (data) {
            case "시작시간변경":
              setSnackbars({
                toggle: true,
                type: "info",
                message: data,
              });
              ProcessNmSearch(_value);
              break;
            case "생산이 종료되었습니다.":
              setSnackbars({
                toggle: true,
                type: "info",
                message: data,
              });
              break;
            case "시작시간을 누르고 작업을 다시 하세요.":
              setSnackbars({
                toggle: true,
                type: "info",
                message: data,
              });
              break;
            case "완료된 공정입니다.":
              setSnackbars({
                toggle: true,
                type: "info",
                message: data,
              });
              break;
            case "이미 완료된 공정입니다.":
              setSnackbars({
                toggle: true,
                type: "info",
                message: data,
              });
              break;
            default:
              for (let i = 0; i < data.length; i++) {
                setWoNoInputs({
                  ...woNoInputs,
                  plantCd: data[i].plantCd,
                  itemCd: data[i].itemCd,
                  worker: inputs.userNm,
                  processCd: data[i].processCd,
                  wkSeq: data[i].wkSeq,
                  woNo: data[i].woNo,
                  wkStDt: data[i].wkStDt,
                  remark: data[i].remark,
                  cartonQuantity: data[i].cartonQuantity,
                });
                setInputs({
                  ...inputs,
                  barcodeValue: "",
                  processNm: data[i].processNm,
                });
                setStartDate(new Date(data[0].wkStDt));
              }
              GetMachineData(inputs.barcodeValue);
              setProcessCdCheck(true);
              break;
          }
        });
      }
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      setInputs({
        ...inputs,
        barcodeValue: "",
      });
      // Dialog.ProgressBar(false);
      setProgressbar(false);
    }
  };

  //지난공정
  const GetLastProcessCd = async () => {
    // Dialog.ProgressBar(true);
    setProgressbar(true);

    let userInfo = null;
    let getLanData = [];
    let getRowData = [];

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10060.GetLastProcessCd,
        {
          woNo: inputs.woNo,
          itemCd: inputs.itemCd,
          processCd: inputs.barcodeValue,
          orSeq: inputs.orSeq,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setWoNoInputs({
            ...woNoInputs,
            plantCd: inputs.plantCd,
            worker: inputs.userNm,
            itemCd: inputs.itemCd,
            processCd: inputs.processCd,
            wkSeq: inputs.orSeq,
            woNo: inputs.woNo,
            wkStDt: new Date(),
          });
          setProcessCdCheck(true);
        } else {
          setLastProcessList({
            ...lsatProcessList,
            createId: data[0].createId,
            processNm: data[0].processNm,
            seqFailQty: data[0].seqFailQty,
            seqQty: data[0].seqQty,
            wkTime:
              Commons.DateDiff(data[0].wkEtDt, data[0].wkStDt, "D") + "시간",
            wkEtDt: data[0].wkEtDt,
            wkStDt: data[0].wkStDt,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      // Dialog.ProgressBar(false);
      setProgressbar(false);
    }
  };

  //저장
  const SaveConfirm = (_type) => {
    setDialog({
      open: true,
      title: "저장",
      children: "저장하시겠습니까?",
      saveButtonName: "저장",
      onSave: () => {
        SaveLogic();
      },
    });
    // BasicDialog();
  };

  const SaveLogic = async () => {
    // Dialog.ProgressBar(true);
    setProgressbar(true);

    let userInfo = null;
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      if (
        machineInputs.machineCd == "" ||
        machineInputs.machineCd == undefined ||
        machineInputs.machineCd == null
      ) {
        throw new Error("설비명을 선택하세요");
      }
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10060.WorkCreate,
        {
          plantCd: woNoInputs.plantCd,
          processCd: woNoInputs.processCd,
          woNo: woNoInputs.woNo,
          wkSeq: woNoInputs.wkSeq,
          itemCd: woNoInputs.itemCd,
          endProcess: inputs.startEnd,
          seqQty: woNoInputs.seqQty,
          seqFailQty: woNoInputs.seqFailQty,
          wkStDt: woNoInputs.wkStDt,
          wkEdDt: woNoInputs.wkEdDt,
          remark: woNoInputs.remark,
          wkOutsrc: woNoInputs.wkOutSrc,
          machineCd: machineInputs.machineCd,
          cartonQuantity: woNoInputs.cartonQuantity,
          compYn: "N",
          createId: userInfo.userId,
          createDate: Commons.DateStrChange(new Date()),
          updateId: userInfo.userId,
          updateDate: Commons.DateStrChange(new Date()),
        }
      ).then((result) => {
        let data = result.data;
        if (data == "carton error") {
          //카톤입수량이 1이거나 없을경우 메시지
          throw new Error(
            lanData.filter(
              (f) => f.lanId === "Snack_CartonError" && f.lanType === "SNACK"
            )[0].lanName
          );
        } else if (data == "Ok") {
          setProcessCdCheck(false);
          setMachineInputs({
            machineCd: "",
          });
          setWoNoInputs({
            wkSeq: -1,
            worker: "",
            wkOutSrc: "Y",
            wkType: "Y",
            wkStDt: "",
            wkEdDt: new Date(),
            seqQty: 0,
            machineCd: "",
            seqFailQty: 0,
            radioJumpQty: "10",
            radioJumpQty1: "10",
            remark: "",
            processCd: "",
            woNo: "",
            itemCd: "",
            endProcess: "",
            remark: "",
          });

          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          setSnackbars({
            toggle: true,
            typ: "error",
            message: data,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      setProgressbar(false);
      // Dialog.ProgressBar(false);
    }
  };
  const ProcMove = async () => {
    navigate("/ManufactureManagement/MM10070");
  };
  // const print = async () => {
  //   try {
  //     let userInfo = null;

  //     await IndexedDb.GetLoginInfo().then((result) => {
  //       userInfo = result;
  //     });
  //     await Commons.Axios(
  //       "post",
  //       Global.serverUrls.useUrl +
  //         Global.urls.logic.Manufacture.MM10060.PrintClient,
  //       {
  //         userId: userInfo.userId,
  //       }
  //     ).then((result) => {
  //       let data = result.data;
  //     });
  //   } catch (e) {
  //     setSnackbars({
  //       toggle: true,
  //       type: "error",
  //       message: e.message,
  //     });
  //   } finally {
  //     Dialog.ProgressBar(false);
  //   }
  // };
  return (
    <>
      {processCdCheck === false ? (
        <Mm10060View
          inputs={inputs}
          setInputs={setInputs}
          WoNoSearch={WoNoSearch}
          UserSearch={UserSearch}
          ProcessCdSearch={ProcessCdSearch}
          setProcessCdCheck={setProcessCdCheck}
          setBomList={setBomList}
          bomList={bomList}
          ProcMove={ProcMove}
          // print={print}
          checkProcessCd={checkProcessCd}
          woNoInputs={woNoInputs}
          setSaveWoNo={setSaveWoNo}
        />
      ) : (
        <Mm10061View
          inputs={inputs}
          setInputs={setInputs}
          WoNoSearch={WoNoSearch}
          UserSearch={UserSearch}
          ProcessCdSearch={ProcessCdSearch}
          setProcessCdCheck={setProcessCdCheck}
          woNoInputs={woNoInputs}
          setWoNoInputs={setWoNoInputs}
          SaveConfirm={SaveConfirm}
          checkProcessCd={checkProcessCd}
          bomList={bomList}
          GetLastProcessCd={GetLastProcessCd}
          setLastProcessList={setLastProcessList}
          lsatProcessList={lsatProcessList}
          startDate={startDate}
          setStartDate={setStartDate}
          machineData={machineData}
          setMachineData={setMachineData}
          machineInputs={machineInputs}
          setMachineInputs={setMachineInputs}
        />
      )}
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
      <BasicDialog
        open={dialog.open}
        title={dialog.title}
        children={dialog.children}
        onClose={() => {
          setDialog({
            ...dialog,
            open: false,
            title: "",
            children: "",
          });
        }}
        closeButtonName="확인"
        saveButtonName={dialog.saveButtonName}
        onSave={() => dialog.onSave()}
      />
      <Progressbar value={progress} />
    </>
  );
}

export default MM10060;
